import type { CountryCode } from "libphonenumber-js";
import type { IParsedPhoneValue } from "../types";

export const parsePhoneValue = (value: string): IParsedPhoneValue | null => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const parts = value.split("-");
  if (parts.length !== 3) return null;

  const [country, code, number] = parts;
  return {
    country: country as CountryCode,
    code,
    number,
  };
};

export const formatPhoneValue = (
  country: CountryCode,
  code: string,
  number: string,
): string => {
  return `${country}-${code}-${number}`;
};
